import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTeamPage } from "../../../redux/actions";
import { flattenTeamMembers, filterTeamMembers, paginateTeamMembers, TEAM_PAGE_SIZE } from "../helpers";

export const useTeamPage = () => {
  const dispatch = useDispatch();
  const { active, pending, inactive, totals, loading } = useSelector(
    (state) => state.TeamPageReducer,
  );
  const updateState = useSelector((state) => state.updateTeamMembersReducer);
  const reactivateState = useSelector((state) => state.reactivateTeamMembersReducer);

  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [page, setPage] = useState(1);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearch(searchValue);
      setPage(1);
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [searchValue]);

  useEffect(() => {
    dispatch(fetchTeamPage({ page: 1, limit: TEAM_PAGE_SIZE }));
  }, [dispatch]);

  useEffect(() => {
    if (updateState.success || reactivateState.success) {
      dispatch(fetchTeamPage({ page: 1, limit: TEAM_PAGE_SIZE }));
    }
  }, [dispatch, reactivateState.success, updateState.success]);

  const members = useMemo(
    () => flattenTeamMembers({ active, pending, inactive }),
    [active, pending, inactive],
  );
  const filteredMembers = useMemo(
    () => filterTeamMembers(members, debouncedSearch),
    [members, debouncedSearch],
  );
  const paginatedMembers = useMemo(
    () => paginateTeamMembers(filteredMembers, page, TEAM_PAGE_SIZE),
    [filteredMembers, page],
  );
  const allocatedSeats = totals.active + totals.pending + totals.inactive;

  return {
    loading,
    searchValue,
    setSearchValue,
    page,
    setPage,
    members: paginatedMembers,
    totalMembers: filteredMembers.length,
    seatSummary: `${members.length}/${allocatedSeats || members.length} seats used`,
  };
};
